export interface Environment {
  name: string;
  production: boolean;
  appInsights: {
    key: string;
  };
  nxApi: {
    base: string;
    subscriptionHeader: {
      name: string;
      value: string;
    };
    fragment: {
      address: string;
      discount: string;
      ticketsAndFares: string;
      checkout: string;
      customer: string;
      order: string;
    };
    minAddressSearchChars: number;
  };
  b2c: {
    authority: string;
    authorityDomain: string;
    clientId: string;
    redirectUris: {
      coventry: {
        redirectUri: string;
        postLogoutRedirectUri: string;
      };
      ['west-midlands']: {
        redirectUri: string;
        postLogoutRedirectUri: string;
      };
    };
    signUpSignInPolicy: string;
  };
  cdnBaseUrl: string;
  gtm: {
    id: string;
  };
}
